import { Guid, SerializableObject } from '../../common-react/core';

import { ChronologicalTypes } from '../other/event-chronological-types.enum';

import { Location } from './location.do';

export class ShipmentTrackingEvent extends SerializableObject {
  public id: Guid;
  public title: string;
  public timestamp?: Date | string;
  public description?: string;
  public location?: Location;
  public chronologicalType?: ChronologicalTypes;

  protected coercePropertyType(propertyName: string, propertyValue: unknown): unknown {
    const returnValue: unknown = super.coercePropertyType(propertyName, propertyValue);

    switch (propertyName) {
      case 'location':
        return propertyValue ? new Location(propertyValue) : undefined;

      case 'timestamp':
        return typeof propertyValue === 'string' ? propertyValue : returnValue instanceof Date ? returnValue : undefined;

      default:
        return returnValue;
    }
  }
}
